/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import CloseIcon from "@mui/icons-material/Close";

export const MyCloseIcon = () => {
  return <CloseIcon color="action" />;
};

export default MyCloseIcon;
